module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('cell', {
    attrs: {
      "title": _vm.title,
      "value": _vm.currentValue,
      "is-link": !_vm.readonly,
      "value-align": _vm.valueAlign,
      "border-intent": _vm.borderIntent
    },
    nativeOn: {
      "click": function($event) {
        return _vm.show($event)
      }
    }
  }, [(!_vm.displayValue && _vm.placeholder) ? _c('span', {
    staticClass: "vux-cell-placeholder"
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._v(" "), (_vm.displayValue) ? _c('span', {
    staticClass: "vux-cell-value"
  }, [_vm._v(_vm._s(_vm.displayValue))]) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_vm._t("icon")], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('popup', {
    staticStyle: {
      "background-color": "#fff"
    },
    on: {
      "on-hide": function($event) {
        _vm.$emit('on-hide')
      },
      "on-show": function($event) {
        _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.showPopup),
      callback: function($$v) {
        _vm.showPopup = $$v
      },
      expression: "showPopup"
    }
  }, [_vm._t("popup-header", null, {
    options: _vm.options,
    value: _vm.currentValue
  }), _vm._v(" "), _c('radio', {
    attrs: {
      "options": _vm.options,
      "fill-mode": false
    },
    on: {
      "on-change": _vm.onValueChange
    },
    scopedSlots: _vm._u([{
      key: "each-item",
      fn: function(props) {
        return [_vm._t("each-item", [_c('p', [_c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.icon),
            expression: "props.icon"
          }],
          staticClass: "vux-radio-icon",
          attrs: {
            "src": props.icon
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "vux-radio-label"
        }, [_vm._v(_vm._s(props.label))])])], {
          icon: props.icon,
          label: props.label,
          index: props.index
        })]
      }
    }]),
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  })], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c14aa1e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/popup-radio/index.vue
// module id = 1012
// module chunks = 1